export const MAX_INVOICE_DISCOUNT_PERCENT = 100
